import axios from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { AxiosUtils } from '../../utils';
import { CurrentUser } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useCurrentUserQuery(
	authToken: string,
	options?: Omit<UseQueryOptions<CurrentUser, unknown, CurrentUser[], string[]>, 'queryKey' | 'queryFn'>
) {
	return useQuery(QueryKeys.CurrentUser(authToken), () =>
		AxiosUtils.getResponseData(
			axios.get<any>(CerebroApiEndpoints.Absolute(CerebroApiEndpoints.Users.Current), {
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
			})
		)
	);
}
